<div>
  <div class="flex justify-center items-center mb-4 text-2xl">
    <tisa-icon icon="lock"></tisa-icon>
  </div>
  <div class="flex flex-col items-center">
    <span>{{ label }}</span>
    <span>
      <a role="link" [routerLink]="signInPath" class="text-primary-400 no-underline">
        {{ actionLabel }}</a
      >
      {{ actionGoalLabel }}
    </span>
  </div>
</div>
